<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong>Notices</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
            label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <template v-if="sendType === 'class'">
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="stream" :items="stream_list" item-text="name" label="Stream"
              @change="handleStreamChange" outlined persistent-hint hint="Please Select Stream"
              :readonly="standard.length > 0" />
          </v-col>
          <v-col sm="1">
            <br />
            <center><strong>OR</strong></center>
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="standard" :items="standard_list_all" item-text="standard"
              item-value="id" label="Standard" multiple @change="handleStandardChange" outlined persistent-hint
              hint="Please Select Standard" :readonly="stream !== ''" />
          </v-col>
          <!-- <v-col sm="2" v-if="division_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="division" :items="division_list" item-value="id" item-text="divname"
              label="Division" outlined multiple @change="get_divisions_student" />
          </v-col> -->
          <v-col sm="2" v-if="division_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="division" :items="division_list" item-value="id" item-text="divname"
              label="Division" outlined multiple @change="get_divisions_student" :rules="divisionRule" return-object />
          </v-col>
          <!-- <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete 
              dense 
              required 
              v-model="selectedDivisionForLearner" 
              :items="division_list" 
              item-text="divname" 
              item-value="id" 
              label="Select Division for Learners" 
              outlined 
              persistent-hint 
              hint="Select a division to fetch learners" 
            />
          </v-col> -->
          <!-- <v-col sm="1">
            <v-btn color="primary" @click="fetchLearners" class="mt-1" block>Fetch</v-btn>
          </v-col> -->
          <v-col sm="2" v-if="learner_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="learner" :items="learner_list" return-object item-text="name"
              item-value="lid" label="Learner" outlined multiple @change="handleLearnerChange" />
          </v-col>
          <v-col sm="2" v-if="learner_list.length > 0">
            <v-text-field class="mt-5" rounded outlined color="#0F2027" flat dense v-model="learner.length"
              name="studcnt" label="No. of student selected" readonly filled />
          </v-col>
        </template>
        <template v-else-if="sendType === 'individual'">
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="standard" :items="standard_list_all" item-text="standard"
              item-value="id" multiple label="Standard" outlined @change="get_standard_divisions()"></v-autocomplete>
          </v-col>
          <v-col sm="2" v-if="division_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="division" :items="division_list" item-value="id" item-text="divname"
              label="Division" outlined multiple @change="get_divisions_student()"></v-autocomplete>
          </v-col>
          <v-col sm="2" v-if="learner_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="learner" :items="learner_list" return-object item-text="name"
              item-value="lid" label="Learner" outlined multiple @change="updateLearnerCount" />
          </v-col>
          <v-col sm="2" v-if="learner_list.length > 0">
            <v-text-field class="mt-5" rounded outlined color="#0F2027" flat dense v-model="learner.length"
              name="studcnt" label="No. of student selected" readonly filled></v-text-field>
          </v-col>
        </template>
      </v-row>
      <br />
      <span v-if="(sendType === 'class' && division != '') || (sendType === 'individual' && learner != '')">
        <v-row dense justify="center">
          <v-col cols="6">
            <v-text-field label="Title" v-model="title" :rules="textRule" required placeholder="Colleges reopens">
              <template v-slot:prepend>
                <v-icon color="red" size="15px">mdi-asterisk</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field label="Link(If Any)" v-model="link" placeholder="URL"
              @change="validateWebinarURL(link)"></v-text-field>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-textarea label="Description" v-model="description" value placeholder="Colleges reopens on...."
            hint="Enter description of notice or home work"></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-file-input v-model="attachments" placeholder="Upload attachment if any" label="Attachment" multiple
            prepend-icon="mdi-paperclip">
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">{{ text }}</v-chip>
            </template>
          </v-file-input>
        </v-col>
        <v-btn @click="putCalendar" :loading="send_btn_load"
          v-if="(sendType === 'class' && division && title) || (sendType === 'individual' && learner && title)"
          color="info" :disabled="isvalid == false ? true : false">Send</v-btn>
      </span>
      <v-row v-if="!isvalid" align="center" justify="space-around">
        <p v-if="!isvalid"><b>{{ Message }}</b></p>
      </v-row>
    </v-card>
    <v-row justify="center">
      <v-col cols="12" sm="2">
        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date" hint="From Date"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field outlined dense type="date" v-model="todate" label="To Date" hint="To Date"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
      </v-col>
    </v-row>
    <v-row dense justify="center" v-if="communication_list != '' && sendType === 'class'">
      <v-radio-group inline v-model="view" row>
        <v-radio label="Single" value="Single"></v-radio>
        <v-radio label="Cummalative" value="Cummalative"></v-radio>
      </v-radio-group>
    </v-row>
    <br />
    <template v-if="communication_list != ''">
      <template v-if="view === 'Single' || sendType === 'individual'">
        <div>
          <div v-if="communication_list.length != 0">
            <v-data-table :items="bookList1" :headers="headers" class="elevation-1 mytable" :search="search"
              @current-items="getFiltered">
              <template v-slot:top>
                <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
                  <v-toolbar-title><b>List of Notices</b> <small>[ AY:{{ d_ay }} || {{ from_date }} to
                      {{ to_date }} ] </small></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="search" append-icon="search" label="Search" rounded background-color="white"
                      color="white" hide-details></v-text-field>
                  </v-col>
                </v-toolbar>
                <v-row dense>
                  <tr class="t-row">
                    <div>
                      <th>
                        <v-row>
                          <span v-for="header in headers" :key="header.text">
                            <span v-if="filters.hasOwnProperty(header.value)">
                              <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                                color="#0F2027" :label="header.text" multiple clearable
                                :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                            </span>
                          </span>
                        </v-row>
                      </th>
                    </div>
                  </tr>
                </v-row>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <v-btn color="success" icon dark @click="getDescription(item.description)" title="View Details">
                  <v-icon>mdi-book-open</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.url`]="{ item }">
                <a :href="item.url" target="_blank" v-if="item.url != '--'">
                  <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                </a>
                <span v-else style="opacity: 0.5;">{{ item.url }}</span>
              </template>
              <template v-slot:[`item.attachment`]="{ item }">
                <span v-if="item.attachment_list.length > 0">
                  <span v-for="(item, i) in item.attachment_list" :key="i">
                    <a class="p-2" :href="basepath + item.link" target="blank">
                      <v-tooltip top>
                        <template v-slot:activator="{ attrs }">
                          <v-btn icon v-if="item.link != null" v-bind="attrs"> <v-icon
                              color="black">mdi-eye</v-icon></v-btn>
                        </template>
                        <span>View Attachment File!!!</span>
                      </v-tooltip>
                    </a>
                  </span>
                </span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div>
                  <v-btn color="secondary" icon dark @click="editDialog(item)" title="Edit Event">
                    <v-icon>mdi-file-document-edit</v-icon>
                  </v-btn>
                  <v-btn color="warning" icon dark @click="deleteCalendarEvent(item)" title="Delete Event"
                    :loading="delete_attach_load">
                    <v-icon>mdi-delete-empty</v-icon>
                  </v-btn>
                  <v-btn color="primary" icon dark @click="getStatus(item.id)" title="Get status">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                  <v-btn color="primary" icon dark @click="editwhenresendDialog(item)" title="Resend Notice">
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </template>
      <template v-if="view === 'Cummalative' && sendType === 'class'">
        <v-row dense>
          <v-col cols="12" sm="12" md="12" v-for="(value, key) in cum_list" :key="key"
            v-if="matchesSearch(value, searchQuery)">
            <v-card class="box box1" fill-height>
              <v-btn style="float: right;" color="primary" icon dark @click="getdataresendCumulative(key)"
                title="Resend Notice">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
              <v-btn class="link" :loading="delete_loader" style="float: right;" @click="deleteCommnByMsgId(key)"
                color="red"> <v-icon>mdi-trash-can</v-icon></v-btn>
              <span v-for="(std, ind) in value" :key="ind">
                <h3 v-if="ind == 0">Title : {{ value[0] }}</h3>
                <div v-else-if="ind == 1">
                  <b>Description:</b>{{ value[1] }} <br>
                  <span>{{ std }}</span><br>
                </div>
                <v-btn v-else color="info" small style="margin: 2px;">
                  {{ std }}
                </v-btn>
              </span>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </template>
    <!-- Dialogs remain unchanged -->
    <v-dialog v-model="description_dialog" max-width="1200px">
      <v-card>
        <v-card-text v-html="show_description.replace(/\n/g, '<br>')"></v-card-text>
        <v-card-actions class="justify-center"><v-btn color="warning"
            @click="description_dialog = false">Close</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="status_dialog" max-width="1200px">
      <v-card>
        <v-card-text>
          <v-data-table :headers="status_headers" :items="comm_read_status" :search="search"
            @current-items="getFiltered" :items-per-page="-1">
            <template v-slot:top>
              <v-toolbar flat color="white" align="center" justify="center">
                <v-toolbar-title>List of Receipients</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <strong>Total Receipients- </strong>{{ total_receipient }}
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                  hide-details></v-text-field>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-center"><v-btn class="dialog-btn"
            @click="status_dialog = false">Close</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" max-width="500px">
      <!-- Edit dialog content remains the same -->
    </v-dialog>
    <v-dialog v-model="edit_when_resend_dialog" max-width="500px">
      <!-- Resend dialog content remains the same -->
    </v-dialog>
    <v-dialog v-model="edit_when_resend_comulative_dialog" max-width="500px">
      <!-- Cumulative resend dialog content remains the same -->
    </v-dialog>
    <div class="text-center">
      <v-dialog v-model="init_loader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

  export default {
    components: {
      Breadcrumbs,
    },
    data: () => ({
      isvalid: true,
      Message: null,
      file_upload_config: { allowed_type: "", max_size: 1000 },
      rules: [(value) => !value || value.size < 2000000 || "Logo size should be less than 2 MB!"],
      textRule: [(v) => !!v || "Field is required"],
      divisionRule: [(v) => (v && v.length > 0 && v.every(item => item && item.id)) || "Please select at least one valid division"],
      attachments: [],
      ay_list: [],
      academicyear: "",
      stream: "",
      stream_list: [],
      standard_list_all: [],
      standard: [],
      event_type_list: [],
      division_list: [],
      standard_list: [],
      division: [],
      learner: [],
      // selectedDivisionForLearner: null, // New property to select division for fetching learners
      event_type: "",
      datetime: null,
      search: "",
      searchQuery: "",
      snackbar_msg: "",
      snackbar: false,
      color: "",
      communication_list: [],
      get_communication_list_for_resend: [],
      awspath: null,
      send_btn_load: false,
      delete_attach_load: false,
      basepath: "",
      description: "",
      link: "",
      edit_save_attachment_load: false,
      edit_attachments: [],
      filterArr: [],
      delete_acttach_load: false,
      filters: {
        title: [],
        date: [],
        to: [],
        employeeName: [],
      },
      status_headers: [
        { text: "Sr No", value: "srno", sortable: true },
        { text: "Read By", value: "learner", sortable: true },
        { text: "Read Date", value: "read_date", sortable: true },
      ],
      headers: [
        { text: "Academicyear", value: "academicyear", sortable: true },
        { text: "Sent Date", value: "date", sortable: true },
        { text: "From", value: "from", sortable: true },
        { text: "Employee Name", value: "employeeName", sortable: true },
        { text: "To", value: "to", sortable: true },
        { text: "Title", value: "title", sortable: true },
        { text: "Description", value: "description", sortable: true },
        { text: "Attachments", value: "attachment", sortable: true },
        { text: "Link", value: "url", sortable: true },
        { text: "Action", value: "action", sortable: true },
      ],
      editedItem: {
        date: null,
        attachment_list: [],
        description: "",
        from: null,
        id: null,
        to: null,
        title: null,
        url: null,
      },
      editedItem_for_comulative_resend: {
        title: '',
        url: '',
        description: '',
        attachment_list: [],
        date: ''
      },
      title: null,
      web_Link: "",
      edit_dialog: false,
      edit_when_resend_dialog: false,
      edit_when_resend_loader: false,
      edit_when_resend_comulative_dialog: false,
      edit_when_resend_comulative_loader: false,
      comm_read_status: [],
      status_dialog: false,
      description_dialog: false,
      show_description: "",
      total_receipient: "",
      d_ay: null,
      init_loader: false,
      delete_loader: false,
      view: "Single", // Default view set to Single
      cum_list: null,
      fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
      todate: new Date().toISOString().slice(0, 10),
      sendType: "class",
      learner_list: [],
    }),
    watch: {},
    methods: {
      getdataresendCumulative(item) {
        const formData = { key: item };
        axios
          .post("/Communication/getdataresendNoticeHWAlbumCumulative", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.get_communication_list_for_resend = res.data.communication_list[0];
              this.editedItem_for_comulative_resend = {
                title: this.get_communication_list_for_resend.title,
                url: this.get_communication_list_for_resend.url,
                from: this.get_communication_list_for_resend.from,
                to: this.get_communication_list_for_resend.to,
                description: this.get_communication_list_for_resend.description,
                attachment_list: this.get_communication_list_for_resend.attachment_list,
                date: this.get_communication_list_for_resend.date,
                key: this.get_communication_list_for_resend.key
              };
              this.edit_when_resend_comulative_dialog = true;
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.init_loader = false;
          });
      },
      resendCumulative() {
        if (!confirm("Are You Sure You Want To Edit And Resend This Communication?")) return;
        this.init_loader = true;
        this.edit_when_resend_comulative_loader = true;
        let formData = new FormData();
        for (var i = 0; i < this.edit_attachments.length; i++) {
          let file = this.edit_attachments[i];
          formData.append("files", file);
        }
        formData.append("title", this.editedItem_for_comulative_resend.title);
        formData.append("link", this.editedItem_for_comulative_resend.url);
        formData.append("description", this.editedItem_for_comulative_resend.description);
        formData.append("key", this.editedItem_for_comulative_resend.key);
        axios
          .post("/Communication/resendNoticeHWAlbumCumulative", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Notice/HW Added Successfully...");
              this.edit_when_resend_comulative_dialog = false;
              this.edit_when_resend_comulative_loader = false;
            } else if (res.data.flag == "No") {
              this.showSnackbar("#b71c1c", res.data.snackbar);
              this.edit_when_resend_comulative_dialog = false;
              this.edit_when_resend_comulative_loader = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
            this.edit_when_resend_comulative_dialog = false;
            this.edit_when_resend_comulative_loader = false;
          })
          .finally(() => {
            this.init_loader = false;
            this.get_ay_std();
            this.fetchNotices();
            this.edit_when_resend_comulative_dialog = false;
            this.edit_when_resend_comulative_loader = false;
          });
      },
      resend() {
        if (!confirm("Are You Sure You Want To Edit And Resend This Communication?")) return;
        this.edit_when_resend_loader = true;
        this.init_loader = true;
        let formData = new FormData();
        for (var i = 0; i < this.edit_attachments.length; i++) {
          let file = this.edit_attachments[i];
          formData.append("files", file);
        }
        formData.append("title", this.editedItem.title);
        formData.append("link", this.editedItem.url);
        formData.append("description", this.editedItem.description);
        formData.append("comm_id", this.editedItem.id);
        axios
          .post("/Communication/resendNoticeHWAlbumSingle", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Notice/HW Added Successfully...");
              this.edit_when_resend_dialog = false;
              this.edit_when_resend_loader = false;
            } else if (res.data.flag == "No") {
              this.showSnackbar("#b71c1c", res.data.snackbar);
              this.edit_when_resend_dialog = false;
              this.edit_when_resend_loader = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.init_loader = false;
            this.get_ay_std();
            this.fetchNotices();
            this.edit_when_resend_dialog = false;
            this.edit_when_resend_loader = false;
          });
      },
      matchesSearch(value, query) {
        const searchString = query.toLowerCase();
        const title = value[0].toLowerCase();
        const description = value[1].toLowerCase();
        return title.includes(searchString) || description.includes(searchString);
      },
      fetchNotices() {
        this.init_loader = true;
        this.view = "Single"; // Reset to Single view after fetching
        const formData = {
          comm_type: "Notice",
          for: this.sendType === 'class' ? "all" : "individual",
          fromdate: this.fromdate,
          todate: this.todate,
          ay: this.academicyear.id,
        };
        axios
          .post("/Communication/getNoticesBetweenDates", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.d_ay = res.data.d_ay;
              this.from_date = res.data.from_date;
              this.to_date = res.data.to_date;
              this.communication_list = this.sendType === 'class' ? res.data.communication_list : res.data.individual_communication_list;
              this.cum_list = res.data.cum_list;
              console.log("cum_list loaded:", this.cum_list); // Debug log
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.init_loader = false;
          });
      },
      async deleteCommnByMsgId(key) {
        this.delete_loader = true;
        const formdata = { key: key };
        try {
          const res = await axios.post("/communication/deleteCommnByMsgId", formdata);
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.get_ay_std();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.delete_loader = false;
        } catch (err) {
          console.log("err", err);
          this.showSnackbar("red", "Something went wrong!!!");
          this.delete_loader = false;
        } finally {
          console.log("bye...");
          this.delete_loader = false;
          this.fetchNotices();
        }
      },
      getDescription(description) {
        this.show_description = description;
        this.description_dialog = true;
      },
      deleteAttachment(attach) {
        const formData = { attach_id: attach.attach_id };
        this.delete_acttach_load = true;
        axios
          .post("/communicationType/deleteAttachment", formData)
          .then((res) => {
            if (res.data.status == "YES") {
              const index = this.editedItem.attachment_list.indexOf(attach);
              this.editedItem.attachment_list.splice(index, 1);
              this.delete_acttach_load = false;
              this.showSnackbar("green", "Attachment Deleted Successfully...");
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.delete_acttach_load = false;
          });
      },
      getFiltered(e) {
        this.filterArr = e;
      },
      columnValueList(val) {
        return this.communication_list.map((d) => d[val]);
      },
      clearData() {
        this.division = [];
        this.stream = "";
        this.title = "";
        this.link = "";
        this.description = "";
        this.attachments = [];
        this.standard = [];
        this.learner = [];
        // this.selectedDivisionForLearner = null; // Clear selected division for learners
        this.academicyear = null;
      },
      getStatus(id) {
        const formData = { comm_id: id };
        axios
          .post("/Communication/getcommunicationStatus", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.comm_read_status = res.data.read_list;
              this.status_dialog = true;
              this.total_receipient = res.data.total_receipient;
            } else if (res.data.flag == "No") {
              this.showSnackbar("#b71c1c", res.data.snackbar);
              this.status_dialog = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => { });
      },
      save() {
        this.edit_save_attachment_load = true;
        let formData = new FormData();
        for (var i = 0; i < this.edit_attachments.length; i++) {
          let file = this.edit_attachments[i];
          formData.append("files", file);
        }
        formData.append("title", this.editedItem.title);
        formData.append("link", this.editedItem.url);
        formData.append("description", this.editedItem.description);
        formData.append("comm_id", this.editedItem.id);
        axios
          .post("/communicationType/saveEditCommunication", formData)
          .then((res) => {
            if (res.data.status == "SUCCESS") {
              this.showSnackbar("#4caf50", "Notice/HW Updated Successfully...");
              this.edit_dialog = false;
              this.get_ay_std();
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.edit_save_attachment_load = false;
            this.edit_attachments = [];
            this.close();
            this.edit_dialog = false;
          });
      },
      editDialog(item) {
        this.awspath = localStorage.getItem("awspath");
        this.editedItem = item;
        this.edit_dialog = true;
      },
      editwhenresendDialog(item) {
        this.awspath = localStorage.getItem("awspath");
        this.editedItem = item;
        this.edit_when_resend_dialog = true;
      },
      validateWebinarURL(link) {
        var myURL = link;
        var mytrimurl = myURL.trim();
        var pattern = new RegExp(
          "^((ft|htt)ps?:\\/\\/)?" +
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
          "((\\d{1,3}\\.){3}\\d{1,3}))" +
          "(\\:\\d+)?" +
          "(\\/[-a-z\\d%@_.~+&:]*)*" +
          "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" +
          "(\\#[-a-z\\d_]*)?$",
          "i"
        );
        if (this.hasWhiteSpace(myURL)) {
          this.isvalid = true;
          return;
        } else if (pattern.test(mytrimurl)) {
          this.isvalid = true;
          return;
        } else {
          this.isvalid = false;
          alert("Please Enter Valid URL...!");
          return;
        }
      },
      // get_divisions_stream(stream, type) {
      //   if (type == "stream") {
      //     const formData = {
      //       ay: this.academicyear.id,
      //       stream: stream.id,
      //     };
      //     this.division = [];
      //     axios
      //       .post("/Communication/get_stream_divisions", formData)
      //       .then((res) => {
      //         if (res.data.flag == "Yes") {
      //           this.division_list = res.data.division_list;
      //         }
      //       })
      //       .catch((error) => {
      //         window.console.log(error);
      //       })
      //       .finally(() => {
      //         this.standard = [];
      //       });
      //   }
      //   if (type == "standard") {
      //     const formData = {
      //       ay: this.academicyear.id,
      //       standard: stream,
      //     };
      //     this.division = [];
      //     axios
      //       .post("/Communication/get_standard_divisions", formData)
      //       .then((res) => {
      //         if (res.data.flag == "Yes") {
      //           this.division_list = res.data.division_list;
      //         }
      //       })
      //       .catch((error) => {
      //         this.showSnackbar("#b71c1c", "Something went wrong...");
      //       })
      //       .finally(() => {
      //         this.stream = "";
      //       });
      //   }
      // },
      // get_standard_divisions() {
      //   const formData = {
      //     ay: this.academicyear.id,
      //     standard: this.standard,
      //   };
      //   axios
      //     .post("/Communication/get_standard_divisions", formData)
      //     .then((res) => {
      //       if (res.data.flag == "Yes") {
      //         this.division_list = res.data.division_list;
      //       }
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong...");
      //     })
      //     .finally(() => { });
      // },
      get_divisions_stream(stream, type) {
        if (type === "stream") {
          if (!stream || !stream.id) {
            this.showSnackbar("#b71c1c", "Please select a valid stream");
            this.division_list = [];
            this.division = [];
            return;
          }
          const formData = {
            ay: this.academicyear.id,
            stream: stream.id,
          };
          this.division = [];
          axios
            .post("/Communication/get_stream_divisions", formData)
            .then((res) => {
              if (res.data.flag === "Yes") {
                this.division_list = res.data.division_list || [];
                console.log("division_list from stream:", this.division_list); // Debug log
                if (this.division_list.length === 0) {
                  this.showSnackbar("#b71c1c", "No divisions found for the selected stream.");
                }
              } else {
                this.showSnackbar("#b71c1c", "Failed to load divisions: " + (res.data.snackbar || "Unknown error"));
                this.division_list = [];
              }
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              console.error("Error in get_divisions_stream:", error);
              this.division_list = [];
            })
            .finally(() => {
              this.standard = [];
            });
        } else if (type === "standard") {
          if (!stream || stream.length === 0) {
            this.showSnackbar("#b71c1c", "Please select at least one valid standard");
            this.division_list = [];
            this.division = [];
            return;
          }
          const formData = {
            ay: this.academicyear.id,
            standard: stream,
          };
          this.division = [];
          axios
            .post("/Communication/get_standard_divisions", formData)
            .then((res) => {
              if (res.data.flag === "Yes") {
                this.division_list = res.data.division_list || [];
                console.log("division_list from standard:", this.division_list); // Debug log
                if (this.division_list.length === 0) {
                  this.showSnackbar("#b71c1c", "No divisions found for the selected standard.");
                }
              } else {
                this.showSnackbar("#b71c1c", "Failed to load divisions: " + (res.data.snackbar || "Unknown error"));
                this.division_list = [];
              }
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              console.error("Error in get_standard_divisions:", error);
              this.division_list = [];
            })
            .finally(() => {
              this.stream = "";
            });
        }
      },
      get_standard_divisions() {
        if (!this.standard || this.standard.length === 0) {
          this.showSnackbar("#b71c1c", "Please select at least one standard");
          this.division_list = [];
          this.division = [];
          return;
        }
        const formData = {
          ay: this.academicyear.id,
          standard: this.standard,
        };
        axios
          .post("/Communication/get_standard_divisions", formData)
          .then((res) => {
            if (res.data.flag === "Yes") {
              this.division_list = res.data.division_list || [];
              console.log("division_list from get_standard_divisions:", this.division_list); // Debug log
              if (this.division_list.length === 0) {
                this.showSnackbar("#b71c1c", "No divisions found for the selected standard.");
              }
            } else {
              this.showSnackbar("#b71c1c", "Failed to load divisions: " + (res.data.snackbar || "Unknown error"));
              this.division_list = [];
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error("Error in get_standard_divisions:", error);
            this.division_list = [];
          })
          .finally(() => {});
      },
      handleStreamChange(selectedStream) {
        if (selectedStream && selectedStream.id) {
          this.standard = []; // Clear standard when stream is selected
          this.get_divisions_stream(selectedStream, 'stream');
        } else {
          this.division_list = [];
          this.division = [];
          this.showSnackbar("#b71c1c", "Please select a valid stream");
        }
      },
      handleStandardChange(selectedStandards) {
        if (selectedStandards && selectedStandards.length > 0) {
          this.stream = ''; // Clear stream when standard is selected
          this.get_divisions_stream(selectedStandards, 'standard');
        } else {
          this.division_list = [];
          this.division = [];
          this.showSnackbar("#b71c1c", "Please select at least one standard");
        }
      },
      handleStreamChange(selectedStream) {
        if (selectedStream) {
          this.standard = []; // Clear standard when stream is selected
        }
        this.get_divisions_stream(selectedStream, 'stream');
      },
      handleStandardChange(selectedStandards) {
        if (selectedStandards.length > 0) {
          this.stream = ''; // Clear stream when standard is selected
        }
        this.get_divisions_stream(selectedStandards, 'standard');
      },
      // get_divisions_student() {
      //   if (!this.division || this.division.length === 0) {
      //     this.learner_list = [];
      //     this.learner = [];
      //     return;
      //   }
      //   const formData = {
      //     ay: this.academicyear.id,
      //     division: this.division.map(d => d.id),
      //   };
      //   this.init_loader = true;
      //   axios
      //     .post("/Communication/get_divisions_student", formData)
      //     .then((res) => {
      //       if (res.data.flag === "Yes") {
      //         this.learner_list = res.data.learner_list || [];
      //         if (this.learner_list.length === 0) {
      //           this.learner = [];
      //         } else {
      //           console.log("Learner list populated:", this.learner_list);
      //         }
      //       } else {
      //         this.showSnackbar("#b71c1c", "Failed to load learners.");
      //         this.learner_list = [];
      //         this.learner = [];
      //       }
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong...");
      //       console.error("Error in get_divisions_student:", error);
      //       this.learner_list = [];
      //       this.learner = [];
      //     })
      //     .finally(() => {
      //       this.init_loader = false;
      //     });
      // },
      get_divisions_student() {
        if (!this.division || this.division.length === 0 || this.division.some(item => !item || !item.id)) {
          this.showSnackbar("#b71c1c", "Please select at least one valid division");
          this.learner_list = [];
          this.learner = [];
          return;
        }
        const formData = {
          ay: this.academicyear.id,
          division: this.division.map(d => d.id).filter(id => id !== null && id !== undefined),
        };
        console.log("get_divisions_student payload:", formData); // Debug log
        this.init_loader = true;
        axios
          .post("/Communication/get_divisions_student", formData)
          .then((res) => {
            if (res.data.flag === "Yes") {
              this.learner_list = res.data.learner_list || [];
              console.log("Learner list populated:", this.learner_list);
              if (this.learner_list.length === 0) {
                this.learner = [];
                this.showSnackbar("#b71c1c", "No learners found for the selected division.");
              }
            } else {
              this.showSnackbar("#b71c1c", "Failed to load learners: " + (res.data.snackbar || "Unknown error"));
              this.learner_list = [];
              this.learner = [];
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error("Error in get_divisions_student:", error);
            this.learner_list = [];
            this.learner = [];
          })
          .finally(() => {
            this.init_loader = false;
          });
      },
      // fetchLearners() {
      //   if (!this.selectedDivisionForLearner) {
      //     this.showSnackbar("#b71c1c", "Please select a division to fetch learners.");
      //     return;
      //   }
      //   this.init_loader = true;
      //   const formData = {
      //     ay: this.academicyear.id,
      //     division: [this.selectedDivisionForLearner],
      //   };
      //   axios
      //     .post("/Communication/get_divisions_student", formData)
      //     .then((res) => {
      //       if (res.data.flag === "Yes") {
      //         this.learner_list = res.data.learner_list || [];
      //         if (this.learner_list.length === 0) {
      //           this.learner = [];
      //           this.showSnackbar("#b71c1c", "No learners found for the selected division.");
      //         } else {
      //           this.showSnackbar("#4caf50", "Learners fetched successfully.");
      //           console.log("Learner list populated:", this.learner_list);
      //         }
      //       } else {
      //         this.showSnackbar("#b71c1c", "Failed to load learners.");
      //         this.learner_list = [];
      //         this.learner = [];
      //       }
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong...");
      //       console.error("Error in fetchLearners:", error);
      //       this.learner_list = [];
      //       this.learner = [];
      //     })
      //     .finally(() => {
      //       this.init_loader = false;
      //     });
      // },
      updateLearnerCount() {
        if (!this.learner || this.learner.length === 0) {
          this.learner = [];
        }
      },
      handleLearnerChange() {
        if (this.learner.includes('all')) {
          this.learner = this.learner_list.filter(learner => learner.lid !== 'all').map(learner => learner.lid);
        }
      },
      hasWhiteSpace(s) {
        var status = false;
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(s)) {
          return true;
        }
        return false;
      },
      // putCalendar() {
      //   if (this.hasWhiteSpace(this.title) || this.title == null) {
      //     this.showSnackbar("#b71c1c", "Please Enter Title");
      //     return;
      //   }
      //   this.send_btn_load = true;
      //   let formData = new FormData();
      //   for (var i = 0; i < this.attachments.length; i++) {
      //     let file = this.attachments[i];
      //     formData.append("files", file);
      //   }
      //   formData.append("ay", this.academicyear.id);
      //   formData.append("title", this.title);
      //   formData.append("link", this.link);
      //   formData.append("description", this.description);
      //   formData.append("type", "Notice");
      //   let url = "";
      //   if (this.sendType === "class") {
      //     for (var i = 0; i < this.division.length; i++) {
      //       let division = this.division[i].id;
      //       formData.append("div", division);
      //     }
      //     for (var i = 0; i < this.standard.length; i++) {
      //       let standard = this.standard[i];
      //       formData.append("standard", standard);
      //     }
      //     formData.append("stream", this.stream.id);
      //     url = "/Communication/putNoticeHWAlbum";
      //   } else if (this.sendType === "individual") {
      //     for (var i = 0; i < this.learner.length; i++) {
      //       let learner = this.learner[i].lid;
      //       formData.append("learner", learner);
      //     }
      //     url = "/Communication/putNoticeToStudent";
      //   }
      //   axios
      //     .post(url, formData, {})
      //     .then((res) => {
      //       if (res.data.msg == "200") {
      //         if (res.data.status == "SUCCESS") {
      //           this.showSnackbar("#4caf50", "Notice/HW Added Successfully...");
      //         } else {
      //           this.showSnackbar("#b71c1c", res.data.status_reason);
      //         }
      //       } else if (res.data.flag == "Yes") {
      //         this.showSnackbar("green", "Sent Successfully...");
      //       }
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong...");
      //       window.console.log(error);
      //     })
      //     .finally(() => {
      //       this.send_btn_load = false;
      //       this.get_ay_std();
      //       this.clearData();
      //       this.fetchNotices();
      //     });
      // },
      putCalendar() {
        // Validate title
        if (this.hasWhiteSpace(this.title) || this.title == null) {
          this.showSnackbar("#b71c1c", "Please Enter Title");
          return;
        }

        // Validate division for class sendType
        if (this.sendType === 'class' && (!this.division || this.division.length === 0 || this.division.some(item => !item || !item.id))) {
          this.showSnackbar("#b71c1c", "Please Select at Least One Valid Division");
          return;
        }

        this.send_btn_load = true;
        let formData = new FormData();
        for (var i = 0; i < this.attachments.length; i++) {
          let file = this.attachments[i];
          formData.append("files", file);
        }
        formData.append("ay", this.academicyear.id);
        formData.append("title", this.title);
        formData.append("link", this.link);
        formData.append("description", this.description);
        formData.append("type", "Notice");
        let url = "";
        if (this.sendType === "class") {
          // Append valid division IDs
          if (this.division && this.division.length > 0) {
            for (let i = 0; i < this.division.length; i++) {
              if (this.division[i] && this.division[i].id) {
                formData.append("div", this.division[i].id);
              }
            }
          }
          if (this.standard && this.standard.length > 0) {
            for (let i = 0; i < this.standard.length; i++) {
              let standard = this.standard[i];
              formData.append("standard", standard);
            }
          }
          if (this.stream && this.stream.id) {
            formData.append("stream", this.stream.id);
          }
          url = "/Communication/putNoticeHWAlbum";
        } else if (this.sendType === "individual") {
          if (this.learner && this.learner.length > 0) {
            for (let i = 0; i < this.learner.length; i++) {
              let learner = this.learner[i].lid;
              formData.append("learner", learner);
            }
          }
          url = "/Communication/putNoticeToStudent";
        }
        axios
          .post(url, formData, {})
          .then((res) => {
            if (res.data.msg == "200" && res.data.status == "SUCCESS") {
              this.showSnackbar("#4caf50", "Notice/HW Added Successfully...");
            } else if (res.data.flag == "Yes") {
              this.showSnackbar("green", "Sent Successfully...");
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason || "Failed to send notice.");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error("Error in putCalendar:", error);
          })
          .finally(() => {
            this.send_btn_load = false;
            this.get_ay_std();
            this.clearData();
            this.fetchNotices();
          });
      },
      get_ay_std() {
        this.init_loader = true;
        const formData = {
          comm_type: "Notice",
          for: this.sendType === 'class' ? "all" : "individual",
        };
        axios
          .post("/Communication/gerInitialData", formData)
          .then((res) => {
            if (res.data.flag == "YES" || res.data.flag == "Yes") {
              this.d_ay = res.data.d_ay;
              this.ay_list = res.data.ay_list;
              this.academicyear = res.data.current_ay;
              this.stream_list = res.data.stream_list_all;
              this.standard_list_all = res.data.standard_list_all;
              this.isvalid = res.data.isvalid;
              this.Message = res.data.Message;
              console.log("academicyear loaded:", this.academicyear); // Debug log
            } else if (res.data.flag == "No") {
              this.d_ay = res.data.d_ay;
              this.ay_list = res.data.ay_list;
              this.academicyear = res.data.current_ay;
              this.stream_list = res.data.stream_list_all;
              this.standard_list_all = res.data.standard_list_all;
              this.isvalid = res.data.isvalid;
              this.Message = res.data.Message;
              console.log("academicyear loaded:", this.academicyear); // Debug log
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.init_loader = false;
            this.fetchNotices(); // Call fetchNotices after loading initial data
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      deleteCalendarEvent(item) {
        this.delete_attach_load = true;
        if (!confirm("Are You Sure You Want To Delete This Communication?")) return;
        const formData = { comm_id: item.id };
        axios
          .post("/communicationType/deleteCommunication", formData)
          .then((res) => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4caf50", res.data.status_reason);
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.delete_attach_load = false;
            this.fetchNotices();
            this.get_ay_std();
          });
      },
    },
    mounted() {
      this.init_loader = true;
      this.get_ay_std();
      this.basepath = localStorage.getItem("awspath");
    },
    computed: {
      isFormValid() {
        if (this.sendType === 'class') {
          return this.academicyear &&
                 (this.stream || this.standard.length > 0) &&
                 this.division.length > 0 &&
                 this.division.every(item => item && item.id) &&
                 this.title &&
                 this.isvalid;
        } else if (this.sendType === 'individual') {
          return this.academicyear &&
                 this.standard.length > 0 &&
                 this.division.length > 0 &&
                 this.division.every(item => item && item.id) &&
                 this.learner.length > 0 &&
                 this.title &&
                 this.isvalid;
        }
        return false;
      },
      bookList1() {
        if (this.communication_list.length == 0) return [];
        return this.communication_list.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        });
      },
    },
  };
</script>

<style scoped>
  .allot-btn,
  .allot-icon,
  .info-icon {
    transition: 0.3s;
  }

  .allot-btn:hover .allot-icon {
    color: white;
  }

  .allot-btn:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
  }

  .info-icon:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
    border-radius: 100%;
  }

  .table-sub-title {
    margin-left: 1%;
    font-weight: 500;
    color: #999;
  }

  @media print {
    body {
      height: 100%;
      width: 100%;
    }

    .no-display {
      display: none !important;
    }

    .v-data-footer,
    .v-data-footer__select,
    .v-data-footer__pagination {
      display: none !important;
      visibility: hidden !important;
    }

    .v-data-table table,
    .v-data-table__wrapper {
      width: 100% !important;
      display: block !important;
    }

    table,
    th,
    td {
      border-collapse: collapse !important;
      border: 1px solid black !important;
      width: 100%;
      text-align: right !important;
    }
  }

  .box1 {
    height: 100%;
  }
</style>